import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import BasicModal from '@app/components/Modal/BasicModal';
import { modalClose } from '@app/store/modal/actions';

const propTypes = {
  alertType: PropTypes.string.isRequired,
  onModalClose: PropTypes.func,
};

const defaultProps = {
  onModalClose() {},
};

export class CustomEmailSettingLogoImageConstraintsAlertModalComponent extends Component {
  constructor(props) {
    super(props);
    const { alertType } = props;
    this.handleLinkOpen = this.handleLinkOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    const alertModalSet = [
      {
        cancelText: '닫기',
        closeText: '크기 줄이는 방법',
        content: '로고 파일 크기는 최대 300kb까지 지원합니다. 파일 크기를 줄인 후 업로드해 주세요.',
        title: '파일 크기 초과',
        type: 'fileSize',
        url: 'https://support.modusign.co.kr/hc/ko/articles/360012385933',
      },
      {
        cancelText: '닫기',
        closeText: '크기 조절 방법',
        content: '로고 이미지 크기를 조절한 후 업로드해 주세요.',
        title: '이미지 크기 초과',
        type: 'imageSize',
        url: 'https://support.modusign.co.kr/hc/ko/articles/360011814253',
      },
    ];
    const alertModal = alertModalSet.find((alert) => alert.type === alertType);
    this.state = {
      ...alertModal,
    };
  }

  handleModalClose() {
    const { onModalClose } = this.props;
    onModalClose();
  }

  handleLinkOpen() {
    const { url } = this.state;
    if (url) {
      const openedWindow = window.open(url, '_blank');
      openedWindow.location.href = url;
      openedWindow.opener = null;
    }
  }

  render() {
    const { cancelText, closeText, title, content } = this.state;
    return (
      <BasicModal
        cancelText={cancelText}
        closeText={closeText && closeText}
        content={content}
        title={title}
        onCancel={this.handleModalClose}
        onClose={this.handleLinkOpen}
      />
    );
  }
}

CustomEmailSettingLogoImageConstraintsAlertModalComponent.propTypes = propTypes;
CustomEmailSettingLogoImageConstraintsAlertModalComponent.defaultProps = defaultProps;

const mapDispatchToProps = {
  onModalClose: modalClose,
};

export default connect(
  null,
  mapDispatchToProps
)(CustomEmailSettingLogoImageConstraintsAlertModalComponent);
